import * as React from "react";
import Modal, { ModalSize } from "../../../../misc/components/modal";
import { WizardActionTypes, WizardState } from '../WizardTypings';
import { ToggleSuppressSession } from "./ToggleSuppressSession";
import { VisibleWizards, Correction } from '../../../Request/DcfRequestReducer';
import { CorrectionPreviewModal } from '../../CorrectionPreviewModal';
import { useWizard } from '../../../Hooks/UseWizard';
import { Form } from "informedv4";
import { CorrectionTypesEnum } from "../../../../misc/api/apiTypes";

export interface SuppressSessionWizardProps {
    isVisible: boolean;
    onClose: () => void;
    originalSuppressState: string;
    onComplete: (corrections: Correction[]) => void;
    correctedSuppressState: string
}

export const SuppressSessionWizard = ({ isVisible, onClose, originalSuppressState, onComplete, correctedSuppressState }: SuppressSessionWizardProps): JSX.Element => {
    const { currentState, dispatch } = useWizard();
    const [correctedSuppressionState, setCorrectedSuppressionState] = React.useState(correctedSuppressState);

    if (!isVisible) {
        return null;
    }

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <Form validateOn="submit" initialValues={{ originalSuppressedState: originalSuppressState, correctedSuppressedState: correctedSuppressState || originalSuppressState }}>
                    <ToggleSuppressSession correctedSuppressState={correctedSuppressionState} originalSuppressState={originalSuppressState} onChange={(newSuppressionState: string) => {
                        setCorrectedSuppressionState(newSuppressionState);
                    }} onNext={(newSuppressionState: string) => {
                        setCorrectedSuppressionState(newSuppressionState);
                        dispatch(WizardActionTypes.Next)
                            }} />
                </Form>
            );
            break;
        case 1:
            const corrections = [{
                sourceCorrection: VisibleWizards.SessionSuppress,
                correctionTypeId: CorrectionTypesEnum.SessionSuppress,
                entity: "Session",
                field: "IsSuppressed",
                oldValue: originalSuppressState,
                newValue: correctedSuppressionState
            }];
            page = (
                <CorrectionPreviewModal
                    corrections={corrections}
                    miscCorrection={null}
                    onNext={(): void => { dispatch(WizardActionTypes.Reset); onComplete(corrections) }}
                    onPrev={(): void => dispatch(WizardActionTypes.Previous)}
                />
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal show={true} header={"Suppress Cough Session"} size={ModalSize.Large} closeModalHandler={onClose} >
            {page}
        </Modal>
    );
};
